import React from 'react';

import editIcon from 'images/icons/invite/edit.svg';
import deleteIcon from 'images/icons/invite/delete.svg';

import { useContext } from '../Context';

export default function Actions({ row }) {
  const { dispatch, actions } = useContext();

  const onEdit = (row) => {
    actions.showEditForm(dispatch, row);
  };

  const onDelete = (e, row) => {
    swal(
      {
        title: '',
        text: 'Do you want to archive this prospect?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Archive',
        cancelButtonText: 'Cancel',
        closeOnConfirm: true,
        closeOnCancel: true,
      },
      (isConfirm) => {
        if (isConfirm) {
          let el = e.target;
          while (el && el.tagName !== 'A') {
            el = el.parentNode;
          }

          el.innerHTML = '<i class="fa fa-spinner fa-spin"></i>';
          actions.delete(dispatch, row.id);
        }
      },
    );
  };

  return (
    <div>
      {row.attributes.deleted_at === '' && (
        <a onClick={(e) => onEdit(row)} className="mr10">
          <img src={editIcon} alt="edit" />
        </a>
      )}
      {row.attributes.deleted_at === '' && (
        <a onClick={(e) => onDelete(e, row)}>
          <img src={deleteIcon} alt="delete" />
        </a>
      )}
    </div>
  );
}
